import { alpha, PaletteOptions } from '@mui/material/styles';
import { gradients } from './gradients';
import { payment } from './payment';
import { primitives } from './primitives';
import './types';

export const paletteDark: PaletteOptions = {
  text: {
    primary: primitives.cream[100],
    secondary: primitives.cream[400],
    subtitle: primitives.cream[200],
    disabled: primitives.gray[300],
    accent: primitives.blue[300],
    highlight: primitives.yellow[300],
    white: primitives.white,
  },
  success: {
    main: primitives.green[500],
  },
  error: {
    main: primitives.red[500],
  },
  background: {
    mainBodyDesktop: primitives.navy[900],
  },
  contentBlockBackground: {
    main: primitives.navy[900],
    secondary: primitives.navy[800],
  },
  chip: {
    main: primitives.navy[900],
  },
  link: {
    main: primitives.blue[400],
  },
  header: {
    menu: {
      color: primitives.cream[100],
    },
    backButton: {
      color: primitives.cream[100],
    },
  },
  button: {
    main: primitives.blue[300],
    mainHover: primitives.blue[300],
    mainDisabled: primitives.gray[400],
    contrastMainText: primitives.navy[900],
    secondary: primitives.navy[500],
    secondaryHover: primitives.navy[500],
    secondaryDisabled: primitives.navy[500],
    contrastSecondaryText: primitives.cream[100],
    contrastTextButtonText: primitives.cream[100],
    option: primitives.navy[700],
    optionBorder: alpha(primitives.cream[100], 0.05),
    optionHover: primitives.blue[400],
    optionPressed: primitives.blue[400],
    optionDisabled: primitives.gray[400],
    optionIcon: primitives.blue[300],
    contrastOptionText: primitives.cream[100],
    image: primitives.navy[600],
    imageHover: primitives.gray[400],
    imageDisabled: primitives.gray[400],
    contrastImageText: primitives.gray[50],
  },
  input: {
    main: alpha(primitives.mist[100], 0.15),
    mainHover: alpha(primitives.mist[100], 0.8),
    mainFocus: primitives.periwinkle[400],
  },
  textField: {
    borderDisabled: alpha(primitives.black, 0.05),
  },
  select: {
    mainBackground: primitives.navy[800],
  },
  checkbox: {
    border: primitives.slate[500],
    checked: primitives.white,
  },
  progressBar: {
    main: primitives.navy[700],
    mainFilled: primitives.blue[300],
    contrastText: primitives.navy[800],
  },
  progressCircularWithValue: {
    main: primitives.navy[700],
    mainFilled: primitives.cyan[300],
  },
  picker: {
    mainActiveText: primitives.gray[50],
    mainInactiveText: alpha(primitives.gray[400], 0.25),
    mainBackgroundAccent: alpha(primitives.white, 0.25),
    secondaryActiveText: primitives.gray[50],
    secondaryInactiveText: primitives.gray[300],
    secondaryBackgroundAccent: primitives.gray[50],
  },
  modal: {
    body: primitives.navy[800],
    border: primitives.navy[700],
    backdrop: alpha(primitives.black, 0.2),
  },
  paywall: {
    cta: primitives.blue[300],
    ctaHover: primitives.blue[300],
    ctaDisabled: primitives.gray[400],
    onCta: primitives.navy[900],
    priceText: primitives.yellow[300],
    ribbon: primitives.yellow[400],
    onRibbon: primitives.navy[800],
    card: gradients.specialOfferCard,
    cardBorder: primitives.blue[400],
    badge: primitives.blue[400],
  },
  upsells: {
    option: primitives.navy[700],
    optionBorder: alpha(primitives.cream[100], 0.05),
    optionChecked: alpha(primitives.blue[400], 0.2),
    optionCheckedBorder: primitives.blue[400],
    radioBorder: primitives.blue[400],
    discountBadge: primitives.green[300],
    onDiscountBadge: primitives.navy[800],
    ribbon: primitives.yellow[400],
    onRibbon: primitives.navy[800],
    promoLabelText: primitives.yellow[300],
    banner: gradients.upsellsBanner,
  },
  askOnboarding: {
    glows: gradients.askOnboardingGlows,
  },
  glow: {
    hero: gradients.heroGlow,
    avatar: gradients.avatarGlow,
  },
  zodiacWheel: {
    glowGradient: gradients.zodiacWheelGlow,
    beamGradient: gradients.zodiacWheelBeam,
  },
  w2aPromotion: {
    stepsRailGradient: gradients.w2aStepsRail,
  },
  payment: {
    ...payment,
    drawer: primitives.navy[800],
    errorCaption: primitives.navy[900],
    errorCaptionBorder: primitives.yellow[400],
  },
};
